export default window
